import classes from 'dom-helpers/class';
import gsap from 'gsap';
import preload from 'preload-js';
import currentLocaleFunction from 'current_locale';
import bindAll from 'lodash/bindAll';
import config from '../pjax/config';
import 'gsap/src/uncompressed/plugins/DrawSVGPlugin';

class Preloader {
    constructor(onComplete) {
        this.preloaded = onComplete;
        this.view = config.$view;

        this.el = document.getElementById('loader');
        this.loader = this.el.querySelector('[data-loader]');
        this.rect = this.loader.querySelector('path');
        this.tip = this.el.querySelector('.hold-tip');
        this.loaded = this.el.querySelector('[data-loading]');
        this.currentLocale = currentLocaleFunction({
            supportedLocales: ['it-IT', 'en-US'],
            fallbackLocale: 'en-US',
        });

        this.queue = new preload.LoadQueue(false);
        this.lastKeyUpAt = 0;

        bindAll(this, ['keyDown', 'keyUp', 'touchStart']);
    }

    init(req, done) {
        classes.addClass(config.$body, 'is-loading');

        const tl = new TimelineMax();
        function allComplete() {
            tl.to('.loader-count', 0.8, {
                autoAlpha: 0,
                display: 'none',
            }).set('.hold-tip', {
                autoAlpha: 0,
                display: 'block',
            }).to('.hold-tip', 0.8, {
                autoAlpha: 1,
                delay: 0.8,
                onComplete: () => {
                    done();
                },
            });
        }

        if (location.href.match('/en/') || location.href.match('/en')) {
            document.querySelector('.hold-tip').innerHTML = 'click and hold to enter';
        } else {
            document.querySelector('.hold-tip').innerHTML = 'clicca e tieni premuto per entrare';
        }

        function onComplete() {
            const percent = parseInt(this.queue.progress * 100);
            this.loaded.innerHTML = percent;
        }

        gsap.to('.loader-count', 0.8, {
            autoAlpha: 1,
            onComplete: () => {
                this.queue.load();
            },
        });

        this.queue.on('fileload', onComplete, this);
        this.queue.on('complete', allComplete, this);
        this.queue.loadManifest(manifest, false);
    }

    animateIn(req, done) {
        this.tl = new TimelineMax({
            paused: true,
            onComplete: () => {
                this.isDone = true;
                done();
                this.preloaded();
            },
        });

        this.tl.to('.hold-tip', 0.6, {
            autoAlpha: 0,
        }).to('#flood-loader', 2, {
            attr: {
                'flood-opacity': '0.4',
            },
            ease: gsap.Power0.easeNone,
        }, '-=0.7').to('.loader-bar', 2, {
            scaleX: 1,
        }, '-=2');

        window.addEventListener('touchstart', this.touchStart);
        window.addEventListener('touchend', this.keyUp);
        window.addEventListener('mousedown', this.touchStart);
        window.addEventListener('mouseup', this.keyUp);

        window.addEventListener('keydown', this.keyDown);
        window.addEventListener('keyup', this.keyUp);
    }

    touchStart() {
        if (this.isDown) {
            return;
        }
        this.isDown = true;
        // e.preventDefault();
        this.tl.timeScale(1).play();
    }

    keyDown(e) {
        if (this.isDown) {
            return;
        }

        const key = e.keyCode;
        this.isDown = true;

        if (key === 32) {
            e.preventDefault();
            this.tl.timeScale(1).play();
        }
    }

    keyUp() {
        this.isDown = false;

        if (!this.isDone) {
            this.tl.timeScale(4).reverse();
        }
    }

    animateOut(req, done) {
        const tl = new TimelineMax({
            paused: true,
            onComplete: done,
        });

        tl.to('.loader-bar', 0.5, {
            scaleX: 0,
            transformOrigin: '100%',
        }).to(this.loader, 1, {
            autoAlpha: 0,
        }, '-=0.4');

        tl.restart();
    }

    destroy(req, done) {
        window.removeEventListener('touchstart', this.touchStart);
        window.removeEventListener('mousedown', this.touchStart);
        window.removeEventListener('mouseup', this.keyUp);
        window.removeEventListener('touchend', this.keyUp);
        window.removeEventListener('keydown', this.keyDown);
        window.removeEventListener('keyup', this.keyUp);

        document.body.removeChild(this.el);
        done();
    }
}

module.exports = Preloader;


const base = '/assets/images/';

const images = [
    'big-1.jpg',
    'big-2.jpg',
    'big-3.jpg',
    'intro-1.jpg',
    'inwind1-1.jpg',
    'inwind1-2.jpg',
    'inwind1-3.jpg',
    'inwind1-4.jpg',
];

const manifest = images.map((x) => `${base}${x}`);



/** WEBPACK FOOTER **
 ** ./sections/preloader.js
 **/